const videoSlider = () => {

	const positionSliderControl = () => {
		const $slider = $('.video-slider__inner');
		const $sliderContent = $('.swiper-slide-active .video-slider__additional-content');
		if ($slider.length !== 0 && $sliderContent.length !== 0) {
			const sliderOffset = $slider.offset().top;
			const contentOffset = $sliderContent.offset().top;
			const controlOffset = contentOffset - sliderOffset - 40;
			$('.swiper-pagination').css('top', controlOffset);
			$('.slider-arrow').css('top', controlOffset);
			window.requestAnimationFrame(positionSliderControl);
		}
	}

	$(window).resize(() => {
		positionSliderControl();
	})

	window.requestAnimationFrame(positionSliderControl);

	positionSliderControl();
};

export default videoSlider;
